import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Box, CircularProgress } from "@mui/material";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type IProps = {
  open: any;
  handleClose: any;
  onAgree: any;
  agreeText: any;
  disagreeText: any;
  loading?: boolean;
  description?: any;
  title: any;
};
const AlertDialog: React.FC<IProps> = ({
  open,
  handleClose,
  onAgree,
  agreeText,
  disagreeText,
  loading = false,
  description = "",
  title,
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
    >
      <DialogTitle>{title}</DialogTitle>
      {description && (
        <DialogContent>{description && <Box>{description}</Box>}</DialogContent>
      )}

      <DialogActions>
        <Button onClick={handleClose}>{disagreeText}</Button>
        <Button variant="contained" onClick={onAgree}>
          {loading ? (
            <CircularProgress size={25} sx={{ color: "white" }} />
          ) : (
            agreeText
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
